<div class="page-header">
  <h2 class="mat-h2">Leagues</h2>
  <div class="page-header-actions">
    <button mat-stroked-button type="button" (click)="refreshSchedules()"
            matTooltip="Re-read each league's scheduled-games subcollection">
      <mat-icon>refresh</mat-icon>
      Recheck schedules
    </button>
    <button mat-flat-button color="primary" type="button" (click)="createLeague()">
      <mat-icon>add</mat-icon>
      Create league
    </button>
  </div>
</div>

<div class="filters">
  <mat-form-field appearance="outline" class="filter-search">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="search" (ngModelChange)="applyFilters()" placeholder="league name or id">
    <mat-icon matPrefix>search</mat-icon>
    <button mat-icon-button matSuffix type="button" *ngIf="search" (click)="search = ''; applyFilters()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Federation</mat-label>
    <mat-select [(ngModel)]="federation" (ngModelChange)="applyFilters()">
      <mat-option value="">All</mat-option>
      <mat-option *ngFor="let f of federations" [value]="f">{{ f }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Licenced</mat-label>
    <mat-select [(ngModel)]="licenced" (ngModelChange)="applyFilters()">
      <mat-option value="all">All</mat-option>
      <mat-option value="yes">Licenced</mat-option>
      <mat-option value="no">Not licenced</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Archived</mat-label>
    <mat-select [(ngModel)]="archived" (ngModelChange)="applyFilters()">
      <mat-option value="all">All</mat-option>
      <mat-option value="yes">Archived</mat-option>
      <mat-option value="no">Not archived</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-checkbox [(ngModel)]="onlyArchiveCandidates" (ngModelChange)="applyFilters()"
                matTooltip="Leagues whose scraped schedule holds no game in the future — safe to archive">
    No future games only
  </mat-checkbox>

  <button mat-button type="button" (click)="resetFilters()">Reset</button>

  <span class="filter-count">{{ rows.length }} / {{ totalCount }}</span>
</div>

<div class="table-scroll">
  <mat-table [dataSource]="rows">
    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef> id</mat-header-cell>
      <mat-cell *matCellDef="let row"> {{ row.league.id }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef> name</mat-header-cell>
      <mat-cell *matCellDef="let row"> {{ row.league.name }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="federation">
      <mat-header-cell *matHeaderCellDef> federation</mat-header-cell>
      <mat-cell *matCellDef="let row"> {{ row.league.federation }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="poweredBy">
      <mat-header-cell *matHeaderCellDef> poweredBy</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <ng-container *ngTemplateOutlet="boolCell; context: {value: !!row.league.poweredBy}"></ng-container>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="licenced">
      <mat-header-cell *matHeaderCellDef> licenced</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <ng-container *ngTemplateOutlet="boolCell; context: {value: !!row.league.licenced}"></ng-container>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="archived">
      <mat-header-cell *matHeaderCellDef> archived</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <ng-container *ngTemplateOutlet="boolCell; context: {value: !!row.league.archived}"></ng-container>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="schedule">
      <mat-header-cell *matHeaderCellDef> schedule</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="schedule-tag pending" *ngIf="row.schedule.state === 'pending'">checking…</span>
        <span class="schedule-tag upcoming" *ngIf="row.schedule.state === 'upcoming'"
              [matTooltip]="'Last game ' + (row.schedule.last | date:'d.M.yyyy')">
          next {{ row.schedule.next | date:'d.M.yyyy' }}
        </span>
        <span class="schedule-tag ended" *ngIf="row.schedule.state === 'ended'"
              matTooltip="No game scheduled in the future — archiving stops the proxy polling">
          ended {{ row.schedule.last | date:'d.M.yyyy' }}
        </span>
        <span class="schedule-tag ended" *ngIf="row.schedule.state === 'noData'"
              matTooltip="No scheduled-games documents for this league">no schedule</span>
        <span class="schedule-tag muted" *ngIf="row.schedule.state === 'notTracked'"
              matTooltip="Server does not scrape this league (no url, or neither the league nor any team is licenced)">
          not tracked
        </span>
        <span class="schedule-tag muted" *ngIf="row.schedule.state === 'skipped'">archived</span>
        <span class="schedule-tag ended" *ngIf="row.schedule.state === 'error'">read failed</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <button mat-icon-button type="button" matTooltip="Update"
                [routerLink]="'/admin/league/' + row.league.id">
          <mat-icon>edit</mat-icon>
        </button>
        <!-- Server-side re-scrape. Hidden where the server doesn't poll the league
             at all, because then nothing would ever clear the flag again. The
             tooltip sits on the wrapper: a disabled button swallows hover, and
             the pending state is the one that most needs explaining. -->
        <span class="action-rescrape" *ngIf="!row.league.archived && isServerTracked(row.league)"
              [matTooltip]="row.league.forceScheduleRefresh
                ? 'Refresh requested — the server picks it up within a minute'
                : 'Re-read this schedule from the federation now'">
          <button mat-icon-button type="button" [disabled]="!!row.league.forceScheduleRefresh"
                  (click)="forceScheduleRefresh(row.league.id)">
            <mat-icon>{{ row.league.forceScheduleRefresh ? 'hourglass_top' : 'cloud_download' }}</mat-icon>
          </button>
        </span>
        <button mat-icon-button type="button" class="action-archive" matTooltip="Archive"
                *ngIf="!row.league.archived" (click)="archiveLeague(row.league.id, true)">
          <mat-icon>archive</mat-icon>
        </button>
        <button mat-icon-button type="button" class="action-restore" matTooltip="Restore"
                *ngIf="row.league.archived" (click)="archiveLeague(row.league.id, false)">
          <mat-icon>unarchive</mat-icon>
        </button>
        <button mat-icon-button type="button" class="action-delete" matTooltip="Delete"
                (click)="deleteLeague(row.league.id)">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columns"></mat-row>
  </mat-table>
</div>

<p class="empty-hint" *ngIf="!loading && !rows.length">No league matches the current filters.</p>

<!-- Booleans read faster as a glyph than as the literal strings "true"/"false". -->
<ng-template #boolCell let-value="value">
  <mat-icon class="bool-icon" [class.bool-on]="value" [attr.aria-label]="value ? 'yes' : 'no'">
    {{ value ? 'check_circle' : 'remove' }}
  </mat-icon>
</ng-template>
